

export class CostReviewSecurityEnUsIntrusionSystem {
  isIntrusionSystemChecked!: boolean;
  integrationWithOtherSystems!: number;
  isNewVendorChecked!: boolean;
  newVendor!: string;
  isReplacementVendorChecked!: boolean;
  replacementVendor!: string;
  isExpansionVendorChecked!: boolean;
  expansionVendor!: string;
  isMonitoringVendorChecked!: boolean;
  monitoringVendor!: string;
  detailedDrawings!: number;
  liftRequired!: number;
  risk!: string;
  numberOfPanels!: number;
  numberOfKeypads!: number;
  numberOfContacts!: number;
  numberOfMotionDetectors!: number;
  localAudibleDevices!: number;
  employeesToTrain!: number;
  lowContractor!: string;
  numberOfBidders!: number;
}
